import React, { Component, useLayoutEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import { Layout } from "./components/Layout";
import { LanguageProvider } from "./i18n/LanguageContext";

import "./custom.css";

import { Toaster } from "./components/ui/toaster";
import SuccessNotification from "./components/ui/SuccessNotification";
import { SuccessNotificationProvider } from "./hooks/use-success-notification";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import viCustom from "./utils/viCustom";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TooltipProvider } from "./components/ui/tooltip";

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const html = document.documentElement;
    const prev = html.style.scrollBehavior; // tắt smooth tạm thời để khỏi “nhảy”
    html.style.scrollBehavior = "auto";
    window.scrollTo(0, 0);
    html.style.scrollBehavior = prev;
  }, [pathname]);

  return null;
}

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
        <LanguageProvider>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={viCustom}
            >
                <TooltipProvider>
                  <SuccessNotificationProvider>
                    <SuccessNotification />

                    <Toaster />
                    <ScrollToTop />
                    <Routes>
                      {/* Nhóm CLIENT */}
                      <Route element={<Layout />}>
                        {AppRoutes.map(({ element, ...rest }, i) => (
                          <Route key={i} {...rest} element={element} />
                        ))}
                      </Route>
                    </Routes>
                  </SuccessNotificationProvider>
                </TooltipProvider>
            </LocalizationProvider>
        </LanguageProvider>
    );
  }
}
